import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'oa-request-list',
  name: '我的申请',
  icon: '申',
  group: 'OA 组件',
  description: '展示当前用户发起的流程申请及状态。',
  defaultProps: {
    title: '我的申请',
    limit: 5
}
}
